var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlaskRound(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.672 0L19.04 2.496v9.376c4.864 1.28 8.448 5.632 8.448 10.784 0 3.776-1.92 7.136-4.896 9.152l-.288.192H9.696c-3.136-1.984-5.184-5.44-5.184-9.344 0-5.056 3.424-9.312 8.16-10.72l.288-.064V2.496L11.36 0h9.312zm-5.184 24.992c-1.024 0-1.824.8-1.824 1.76 0 .992.8 1.792 1.824 1.792.992 0 1.824-.8 1.824-1.792 0-.96-.832-1.76-1.824-1.76zM17.28 2.4h-2.56v11.136l-1.152.416c-3.936 1.056-6.72 4.48-6.816 8.416l-.032.288h18.56c0-3.968-2.688-7.456-6.56-8.608l-.288-.096-1.152-.416V2.4zm-6.688 16.672c.64 0 1.152.512 1.152 1.12 0 .64-.512 1.12-1.152 1.12s-1.152-.48-1.152-1.12c0-.608.512-1.12 1.152-1.12zm8.544-3.04c1.344 0 2.432 1.056 2.432 2.336 0 1.312-1.088 2.368-2.432 2.368s-2.432-1.056-2.432-2.368c0-1.28 1.088-2.336 2.432-2.336z"
  })));
}

export default SvgFlaskRound;